export default {
  common: {
    account: 'Аккаунт',
    agents: 'Агенттер',
    all: 'Барлығы',
    available: 'Қолжетімді',
    cancel: 'Болдырмау',
    cloud: 'Бұлт',
    copy: 'Көшіру',
    current: 'ағымдағы',
    delete: 'Жою',
    error: 'Қате',
    export: 'Экспорт',
    help: 'Көмек',
    home: 'Басты бет',
    language: 'Тіл',
    links: 'Сілтемелер',
    loading: 'жүктелуде',
    local: 'Жергілікті',
    login: 'Кіру',
    logout: 'Шығу',
    metadata: 'Метадеректер',
    more: 'Тағы',
    name: 'Атауы',
    never: 'Ешқашан',
    none: 'жоқ',
    notes: 'Жазбалар',
    ok: 'Жарайды',
    open: 'Ашу',
    password: 'құпиясөз',
    project: 'жоба',
    projects: 'Жобалар',
    publicLink: 'Жария сілтеме',
    register: 'Тіркелу',
    remove: 'Алып тастау',
    save: 'Сақтау',
    search: 'Іздеу',
    settings: 'Баптаулар',
    subscribe: 'Жазылу',
    track: 'трек',
    tracks: 'Тректер',
    unknown: 'Белгісіз',
    unknownArtist: 'Белгісіз орындаушы',
    upload: 'Жүктеу',
    username: 'пайдаланушы аты'
  },
  time: {
    day: 'күн',
    days: 'күн',
    daysAgo: (ctx) => `${ctx.named('count')} күн бұрын`,
    hoursAgo: (ctx) => `${ctx.named('count')} сағат бұрын`,
    minutesAgo: (ctx) => `${ctx.named('count')} минут бұрын`,
    rightNow: 'дәл қазір',
    duration: (ctx) => {
      const minutes = Number(ctx.named('minutes'))
      const seconds = Number(ctx.named('seconds'))
      if (minutes > 0) return `${minutes} минут ${seconds} секунд`
      return `${seconds} секунд`
    }
  },
  topBar: {
    accountFallback: 'Аккаунт',
    storage: 'Сақтау орны',
    language: 'Тіл'
  },
  commandPalette: {
    placeholder: 'Тректер мен жобаларды іздеу...',
    projects: 'Жобалар',
    tracks: 'Тректер',
    pages: 'Беттер',
    noResults: 'Нәтиже табылмады',
    quickLinks: 'Жылдам сілтемелер',
    page: {
      home: 'Басты бет',
      account: 'Аккаунт',
      agents: 'Агенттер',
      links: 'Сілтемелер',
      settings: 'Баптаулар',
      help: 'Көмек'
    }
  },
  explorer: {
    searchTitle: 'Іздеу',
    trackCount: (ctx) => `${ctx.named('count')} трек`
  },
  emptyState: {
    hello: 'сәлем',
    addTrack: 'Трек қосу',
    addTrackSubtitle: 'бастау үшін',
    dragDrop: 'Сүйреп апару',
    dragDropSubtitle: 'файлдарды жылдам жүктеу үшін',
    switchStorage: 'Ауыстыру',
    switchStorageSubtitle: 'жоғарғы мәзірде бұлт пен жергілікті режим арасында',
    installAgent: 'Агент орнату',
    installAgentSubtitle: 'файлдарды автоматты түрде жүктеу үшін',
    playTrack: 'Тректі ойнату',
    playTrackSubtitle: 'эффектілерді қолдану үшін төменгі плеерді ашыңыз',
    community: 'сұрақтарыңыз бар ма? {discord} және {telegram} қауымдастықтарымызға қосылыңыз.'
  },
  create: {
    createProject: 'Жоба жасау',
    uploadTrack: 'Трек жүктеу',
    newProject: 'Жаңа жоба',
    artist: 'Орындаушы',
    name: 'Атауы',
    create: 'Жасау',
    loading: 'Жүктелуде...',
    uploadCover: 'Мұқаба жүктеу'
  },
  upload: {
    ariaLabel: 'Трек жүктеу',
    uploadTrack: 'Трек жүктеу',
    analyzing: 'Талдау...',
    fileAdded: '"{name}" файлы қосылды',
    fileReadError: 'Файлды оқу қатесі.',
    errorWithMessage: 'Қате: {message}'
  },
  dragDrop: {
    dropToUpload: 'Жүктеу үшін жіберіңіз',
    deleteDrop: 'Тректі біржола жою үшін осында жіберіңіз'
  },
  project: {
    upload: 'Жүктеу',
    noTracks: 'Тректер жоқ',
    createdBy: 'жасаған',
    trackSummary: (ctx) => `${ctx.named('count')} трек, ${ctx.named('duration')}`,
    play: 'Ойнату',
    pause: 'Кідірту'
  },
  trackItem: {
    more: 'Тағы',
    copyPublicLink: 'Жария сілтемені көшіру',
    savedLocally: 'Жергілікті сақталды',
    saveLocal: 'Жергілікті сақтау орнына сақтау',
    saving: 'Сақталуда...',
    saveCloud: 'Бұлтқа сақтау',
    deleteTrack: 'Тректі жою',
    moveUp: 'Жоғары жылжыту',
    moveDown: 'Төмен жылжыту',
    removeFromProject: '{project} жобасынан алып тастау',
    moveToProject: 'Жобаға жылжыту',
    currentProject: '(ағымдағы)',
    confirmDelete: 'Бұл тректі жойғыңыз келетініне сенімдісіз бе?',
    linkCopiedTitle: 'Сілтеме көшірілді',
    linkCopiedDescription: 'Жария сілтеме буферге көшірілді'
  },
  trackView: {
    created: '{time} жасалды',
    tabs: {
      notes: 'Жазбалар',
      metadata: 'Метадеректер'
    },
    notFound: 'трек табылмады немесе сізге қолжетімді емес',
    untitled: 'Атаусыз'
  },
  notes: {
    placeholder: 'Бұл трек туралы жазба қосыңыз...',
    saving: 'Сақталуда...',
    saveError: 'Жазбаларды сақтау мүмкін болмады. Қайталап көріңіз.'
  },
  metadata: {
    trackOrder: 'Трек реті',
    artist: 'Орындаушы',
    name: 'Атауы',
    key: 'Тональдік',
    mode: 'Режим',
    deleteTrack: 'Тректі жою',
    saveError: 'Метадеректерді сақтау мүмкін болмады. Қайталап көріңіз.'
  },
  lufs: {
    momentary: 'Моменттік LUFS',
    shortTerm: 'Қысқа мерзімді LUFS',
    integrated: 'Интегралды LUFS'
  },
  effects: {
    pitchshift: 'Тонды өзгерту',
    speed: 'Жылдамдық',
    balance: 'Баланс',
    volume: 'Дыбыс деңгейі',
    reverberation: 'Реверберация',
    distortion: 'Дисторшн',
    bitcrush: 'Биткраш',
    saveCurrentEffectsAs: 'Ағымдағы эффектілерді былай сақтау',
    presetName: 'Атауы',
    add: 'Қосу',
    availablePresets: 'Қолжетімді пресеттер',
    tune: 'Баптау',
    eq: 'EQ',
    fx: 'FX',
    presets: 'Пресеттер',
    center: 'Ортасы',
    left: 'Сол',
    right: 'Оң'
  },
  exportPanel: {
    applyEffects: 'Ағымдағы эффектілерді қолдану',
    applyEffectsSubtitle: 'Ағымдағы эффектілер қолданылған тректі экспорттау',
    exportWav: 'WAV ретінде экспорттау',
    exportMp3: 'MP3 ретінде экспорттау',
    exporting: 'Экспортталуда...',
    exportAsNewTrack: 'Жаңа трек ретінде экспорттау',
    creatingTrack: 'Трек жасалуда...',
    downloadOriginal: 'Түпнұсқаны жүктеу',
    originalUnavailable: 'Түпнұсқа файл қолжетімді емес.',
    downloadOriginalFailed: 'Түпнұсқа файлды жүктеу мүмкін болмады.',
    exportAudioFailed: 'Трек аудиосын экспорттау мүмкін болмады.',
    waveformFailed: 'Толқын пішінін жасау мүмкін болмады.',
    createTrackFailed: 'Экспортталған тректі жасау мүмкін болмады.',
    createTrackAlert: 'Экспортталған тректі жасау мүмкін болмады: {message}',
    exportedSuffix: ' (экспорт)',
    copySuffix: ' (көшірме)'
  },
  publicLink: {
    copy: 'Көшіру',
    open: 'Ашу',
    linkCopiedTitle: 'Сілтеме көшірілді',
    linkCopiedDescription: 'Жария сілтеме буферге көшірілді'
  },
  settings: {
    tabs: {
      settings: 'Баптаулар',
      account: 'Аккаунт',
      links: 'Сілтемелер',
      agents: 'Агенттер'
    },
    display: 'Көрініс',
    language: 'Тіл',
    showBpm: 'Трек көрінісінде BPM көрсету',
    showBpmSubtitle: 'Трек тізімінде әр тректің минутына соққы санын көрсету үшін осы баптауды қосыңыз',
    showLufs: 'Трек көрінісінде LUFS көрсету',
    showLufsSubtitle: 'Трек тізімінде әр тректің дыбыс қаттылығын көрсету үшін осы баптауды қосыңыз',
    showKey: 'Трек көрінісінде тональдікті көрсету',
    showKeySubtitle: 'Трек тізімінде әр тректің тональдігі мен режимін көрсету үшін осы баптауды қосыңыз',
    playback: 'Ойнату',
    liveLoudness: 'Нақты уақыттағы дыбыс қаттылығын өлшеу',
    liveLoudnessSubtitle: 'Плеер экранында нақты уақыттағы дыбыс қаттылығы индикаторын көрсету үшін осы баптауды қосыңыз',
    persistEffects: 'Қолданылған эффектілерді барлық тректер үшін сақтау',
    persistEffectsSubtitle: 'Трек өзгерсе де қолданылған эффектілерді сақтап тұру үшін осы баптауды қосыңыз',
    keyboardShortcuts: 'Пернетақта қысқартулары',
    search: 'Іздеу',
    pressShortcut: 'Қажетті пернелер тіркесімін басыңыз',
    storage: 'Сақтау орны',
    resetPresetsInfo: 'Осы браузерде сақталған барлық пресеттерді қалпына келтіру',
    resetPresets: 'Пресеттерді қалпына келтіру',
    resetAllWarning: 'Ескерту! Төмендегі батырма жергілікті сақтау орнындағы барлық деректерді жояды!',
    resetAllData: 'Барлық жергілікті деректерді қалпына келтіріп, барлық тректер мен жобаларды жою',
    loadingAccount: 'Аккаунт жүктелуде...',
    loadingLinks: 'Сілтемелер жүктелуде...',
    loadingAgents: 'Агенттер жүктелуде...',
    authPrompt: 'Бұл бөлімді пайдалану үшін кіріңіз немесе тіркеліңіз.',
    loginRegister: 'Кіру немесе тіркелу',
    pageTitle: {
      settings: 'баптаулар',
      account: 'аккаунт баптаулары',
      links: 'жария сілтемелер',
      agents: 'агенттер'
    },
    presetsCleared: 'Пресеттер сақтау орны тазартылды',
    localDataDeleted: 'Барлық жергілікті деректер жойылды',
    linkCopied: 'Сілтеме көшірілді',
    linkCopyFailed: 'Сілтемені көшіру мүмкін болмады'
  },
  account: {
    hello: 'Сәлем, {name}.',
    subscriptionStatus: 'Қазір жазылым күйі: {status}',
    noSubscription: 'Белсенді жазылым жоқ.',
    manageSubscription: 'Жазылым мен төлем әдістерін басқару',
    subscribeCloud: 'Бұлтты пайдалану үшін жазылыңыз',
    changeUsername: 'Пайдаланушы атын өзгерту',
    changePassword: 'Құпиясөзді өзгерту',
    saveUsername: 'Пайдаланушы атын сақтау',
    savePassword: 'Құпиясөзді сақтау',
    newPassword: 'жаңа құпиясөз',
    confirmPassword: 'құпиясөзді растау',
    usernamePlaceholder: 'пайдаланушы атыңыз',
    storageUsage: 'Сақтау орнын пайдалану',
    baseStorage: 'Негізгі сақтау орны',
    subscriptionStorage: 'Жазылым сақтау орны',
    used: 'Пайдаланылды',
    available: 'Қолжетімді',
    deletedFilesNotice: 'Жақында файлдарды жойған болсаңыз, олар әлі де осы метрикаларға кіруі мүмкін. Алаңдамаңыз - бұл бірнеше сағат ішінде өзгереді.',
    accountId: 'аккаунт id',
    currentPeriodEnds: (ctx) => `ағымдағы төлем кезеңі ${ctx.named('count')} ${ctx.named('label')} кейін аяқталады`,
    accessEnds: (ctx) => `жазылымға қол жеткізу ${ctx.named('count')} ${ctx.named('label')} кейін аяқталады`,
    lastPaymentEnded: (ctx) => `соңғы төлем кезеңі ${ctx.named('date')} күні аяқталды`,
    previousBillingDate: 'алдыңғы төлем күні',
    billingPortalError: 'Төлем порталы қатесі',
    billingPortalFailed: 'Төлем порталын ашу мүмкін болмады.',
    loginRequiredUpdate: 'Профильді жаңарту үшін жүйеге кіруіңіз керек.',
    usernameEmpty: 'Пайдаланушы аты бос болмауы керек.',
    usernameUnchanged: 'Пайдаланушы аты өзгермеді.',
    usernameUpdated: 'Пайдаланушы аты жаңартылды',
    usernameUpdateFailed: 'Пайдаланушы атын жаңарту мүмкін болмады. Қайталап көріңіз.',
    passwordEmpty: 'Құпиясөз бос болмауы керек.',
    passwordsMismatch: 'Құпиясөздер сәйкес келмейді.',
    passwordUpdated: 'Құпиясөз жаңартылды',
    passwordUpdateFailed: 'Құпиясөзді жаңарту мүмкін болмады. Қайталап көріңіз.'
  },
  links: {
    title: 'Жария сілтемелер',
    description: 'Барлық жария сілтемелеріңіз осында көрсетіледі - оларға қол жеткізген кез келген адам жобаны немесе тректі тыңдай алады.',
    cloudOnly: 'Жария сілтемелер тек Бұлт режимінде қолжетімді. Жария сілтемелер жасау және басқару үшін Бұлт сақтау орнына ауысыңыз.',
    noLinks: 'Жария сілтемелер жоқ',
    createFirst: 'Бөлісуді бастау үшін алғашқы жария сілтемеңізді жасаңыз.',
    confirmDelete: 'Бұл сілтемені жойғыңыз келетініне сенімдісіз бе?',
    notFoundTitle: 'Сілтеме табылмады немесе мерзімі өтті',
    notFoundDescription: 'Ашқыңыз келген сілтеме жарамсыз немесе мерзімі өткен.',
    unknownUser: 'белгісіз'
  },
  agents: {
    authorizeTitle: 'Агентке рұқсат беру',
    authorizeDescription: 'Бұл агентке аккаунтыңызға қосылуға рұқсат беріңіз.',
    loginToAuthorize: 'Бұл агентке рұқсат беру үшін жүйеге кіріңіз.',
    wantsConnect: 'Бұл агент аудио файлдарды автоматты түрде жүктеу үшін аккаунтыңызға қосылғысы келеді.',
    permissionUpload: 'Тректерді жүктеу',
    permissionMetadata: 'Трек метадеректерін жасау',
    authorize: 'Рұқсат беру',
    cancel: 'Болдырмау',
    authorizedTitle: 'Агентке рұқсат берілді',
    authorizedDescription: 'Енді бұл терезені жауып, агент қолданбасына орала аласыз.',
    desktopTitle: 'Desktop Agent',
    installDescription: 'Жаңа рендерленген тректерді автоматты түрде жүктеу үшін demoparty агентін PC немесе Mac жүйесіне орнатыңыз.',
    warningLabel: 'ЕСКЕРТУ: ',
    alphaWarning: 'агент alpha күйінде және тұрақсыз болуы мүмкін.',
    downloadMacApple: 'Apple Silicon бар Mac үшін жүктеу',
    downloadMacIntel: 'Intel бар Mac үшін жүктеу',
    downloadWindows: 'Windows x64 үшін жүктеу',
    signingNotice: 'Жоба әлі әзірленіп жатқандықтан, бұл жинақтарға цифрлық қолтаңба қойылмаған. Іске қосқанда қауіпсіздік ескертулері қалыпты жағдай. Қолтаңбасы бар жинақтар кейін беріледі.',
    activeTitle: 'Белсенді агенттер',
    connectedDescription: 'Аккаунтыңызға қосылған агенттер.',
    loginToManage: 'Агенттерді басқару үшін жүйеге кіріңіз.',
    noAgents: 'Әзірге қосылған агенттер жоқ.',
    lastUsed: 'Соңғы қолданылған',
    revoke: 'Қайтарып алу',
    remove: 'Алып тастау',
    confirmRemove: 'Бұл агентті алып тастағыңыз келетініне сенімдісіз бе?',
    authorizeFailed: 'Агентке рұқсат беру мүмкін болмады. Қайталап көріңіз.'
  },
  login: {
    intro: 'Бұлт мүмкіндіктері мен жазылым артықшылықтарын пайдаланғыңыз келсе, жүйеге кіруіңіз керек. Әйтпесе, сервисті жергілікті режимде тегін пайдалана аласыз.',
    subscriptionBenefits: 'жазылым артықшылықтары',
    login: 'Кіру',
    register: 'Тіркелу',
    forgot: 'Құпиясөзімді ұмыттым',
    email: 'e-mail',
    password: 'құпиясөз',
    repeatPassword: 'құпиясөзді қайталау',
    or: 'немесе',
    google: 'Google арқылы кіру',
    apple: 'Apple арқылы кіру',
    resetPassword: 'Құпиясөзді қалпына келтіру',
    resetDescription: 'Жаңа құпиясөз орната алуыңыз үшін кіру сілтемесін жібереміз.',
    sendResetLink: 'Қалпына келтіру сілтемесін жіберу',
    invalidToken: 'Токен жарамсыз немесе мерзімі өткен',
    enterEmail: 'E-mail енгізіңіз',
    resetSent: 'Егер аккаунт бар болса, e-mail мекенжайыңызға кіру сілтемесін жібердік.',
    resetFailed: 'Қалпына келтіру сілтемесін жіберу мүмкін болмады. Қайталап көріңіз.'
  },
  googleCallback: {
    wait: 'Күте тұрыңыз, жүйеге кіргізіп жатырмыз...'
  },
  subscribe: {
    cloudRequiredTitle: 'Бұлт сақтау орны қажет',
    cloudRequiredMessage: 'Бұл мүмкіндік тек бұлт сақтау орнында қолжетімді және белсенді жазылымды талап етеді.',
    title: 'Жергілікті бастаңыз. Авто-жүктеу үшін жаңартыңыз.',
    description: 'Бұлт барлық құрылғыларда синхрондалған бір кітапхана береді.',
    localFree: 'Қолданбаны жергілікті режимде тегін пайдалана аласыз.',
    cloudIncludes: 'Бұлт құрамында',
    featureLibrary: 'Web және iPhone арасында синхрондалған бір кітапхана',
    featureAgent: 'Жаңа рендерлерді автоматты жүктейтін desktop agent',
    featureStorage: 'Тректерге арналған 100 GB бұлт сақтау орны',
    featureLinks: 'Тректер мен жобаларға тұрақты жария сілтемелер',
    featureTools: 'Барлық жергілікті талдау, эффект және экспорт құралдары қосылған',
    monthly: 'Ай сайын',
    monthlyDescription: 'Бұлт синхрондау, кез келген уақытта бас тарту',
    yearly: 'Жыл сайын',
    yearlyDescription: 'Бұлт синхрондау үшін ең тиімді',
    saveTen: '10% үнемдеу',
    perMonth: '/ай',
    billedMonthly: 'Ай сайын төленеді',
    billedYearly: '$53.89 жыл сайын төленеді',
    openingCheckout: 'Checkout ашылуда...',
    subscribePlan: '{plan} жоспарына жазылу',
    registerSubscribe: 'Тіркелу және жазылу',
    securePayment: 'Polar арқылы қауіпсіз төлем. Аккаунт баптауларынан кез келген уақытта бас тартуға болады.',
    customPlan: 'Жеке жоспар керек пе немесе сұрағыңыз бар ма? Бізге жазыңыз:',
    privacy: 'Құпиялылық саясаты',
    terms: 'Қызмет көрсету шарттары',
    refund: 'Қайтару саясаты',
    checkoutFailed: 'Checkout жасау мүмкін болмады. Қайталап көріңіз.'
  },
  thanks: {
    title: 'Жазылымыңыз үшін рақмет!',
    description: 'Енді бұлт сақтау орнын пайдалана аласыз. Жазылымды басқару үшін аккаунт бетіне өтіңіз.',
    startWorking: 'Жұмысты бастау',
    communities: 'Қауымдастықтарға қосылу',
    support: 'Мәселе болса, {email} арқылы немесе жоғарыдағы қауымдастық сілтемелерімен бізге хабарласыңыз.'
  },
  help: {
    title: 'Көмек',
    intro: 'demoparty - аяқталмаған музыка мен жұмыс үстіндегі жобаларға арналған workspace. Ол демоларды сақтауға, эффектілер қолдануға, тегтерді өңдеуге және техникалық метадеректерді бақылауға мүмкіндік береді. Жергілікті пайдалану толық тегін.',
    uploadTitle: 'Жүктеу',
    uploadText: 'Басты беттегі Add батырмасын басып трек қоса аласыз. Жүктеу кезінде жүйе тональдікті, BPM және LUFS мәндерін автоматты түрде анықтайды. Жүктеу аяқталғаннан кейін растау хабарламасын аласыз.',
    storageTitle: 'Сақтау орны',
    storageText: 'demoparty екі сақтау опциясын ұсынады: жергілікті және бұлт.',
    localStorageText: 'Жергілікті сақтау барлық деректерді тек құрылғыңызда сақтайды. Тректер мен жобалар тек жүктелген браузерде қолжетімді. Сақтау үшін IndexedDB қолданылады. Тіркелу қажет емес және деректер ешқайда жіберілмейді.',
    cloudStorageText: 'Бұлт сақтау деректеріңізді demoparty серверлерінде сақтайды. Тректеріңізге кез келген жерден, кез келген уақытта қол жеткізе аласыз. Тіркелу және белсенді жазылым қажет.',
    agentsTitle: 'Агенттер',
    agentsText: 'Бұлт сақтау орнын пайдаланғанда desktop agent орната аласыз. Агент жаңа рендерленген тректерді бұлтқа автоматты түрде жүктейді.',
    publicLinksTitle: 'Жария сілтемелер',
    publicLinksText: 'Бұлт қолданушылары тректер мен жобаларға жария сілтемелер жасай алады. Жоба бетінде сілтеме батырмасын басыңыз. Тректер үшін трек dropdown мәзіріндегі сол белгішені қолданыңыз. Барлық жасалған сілтемелерді Баптаулардан басқаруға болады.',
    exportTitle: 'Экспорт',
    exportText: 'Тректерді қолданылған барлық эффектілермен экспорттауға болады. Трек бетін ашып, Экспорт таңдаңыз. Түпнұсқа файлды жүктей аласыз немесе MP3 не WAV ретінде экспорттай аласыз.',
    supportTitle: 'Қолдау',
    supportText: "demoparty бұлт жазылымдарына қатысты сұрақтар бойынша support{'@'}demoparty.app мекенжайына жазыңыз.",
    attributionsTitle: 'Атрибуциялар',
    attributionsText: 'Бұл жобаны жасауға келесі кітапханалар көмектесті. Алғыс олардың тиісті әзірлеушілеріне тиесілі.'
  },
  cover: {
    upload: 'Мұқаба жүктеу',
    change: 'Мұқабаны өзгерту',
    delete: 'Мұқабаны жою',
    loading: 'Жүктелуде...',
    selectImage: 'Сурет файлын таңдаңыз',
    uploadError: 'Мұқаба суретін жүктеу қатесі'
  }
}
